/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Save_ButtonInputs */

const en_audio_recorder_save_button = /** @type {(inputs: Audio_Recorder_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save`)
};

const fr_audio_recorder_save_button = /** @type {(inputs: Audio_Recorder_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer`)
};

const de_audio_recorder_save_button = /** @type {(inputs: Audio_Recorder_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speichern`)
};

const it_audio_recorder_save_button = /** @type {(inputs: Audio_Recorder_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva`)
};

const ru_audio_recorder_save_button = /** @type {(inputs: Audio_Recorder_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранять`)
};

const es_audio_recorder_save_button = /** @type {(inputs: Audio_Recorder_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahorrar`)
};

const zh_cn2_audio_recorder_save_button = /** @type {(inputs: Audio_Recorder_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`节省`)
};

const ja_audio_recorder_save_button = /** @type {(inputs: Audio_Recorder_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存`)
};

const hi_audio_recorder_save_button = /** @type {(inputs: Audio_Recorder_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बचाना`)
};

const pt_pt2_audio_recorder_save_button = /** @type {(inputs: Audio_Recorder_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar`)
};

/**
* | output |
* | --- |
* | "Save" |
*
* @param {Audio_Recorder_Save_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_save_button = /** @type {((inputs?: Audio_Recorder_Save_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Save_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_recorder_save_button(inputs)
	if (locale === "de") return de_audio_recorder_save_button(inputs)
	if (locale === "it") return it_audio_recorder_save_button(inputs)
	if (locale === "ru") return ru_audio_recorder_save_button(inputs)
	if (locale === "es") return es_audio_recorder_save_button(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_recorder_save_button(inputs)
	if (locale === "ja") return ja_audio_recorder_save_button(inputs)
	if (locale === "hi") return hi_audio_recorder_save_button(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_recorder_save_button(inputs)
	return en_audio_recorder_save_button(inputs)
});